import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const connectionString =
    process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING;

export const appInsights = new ApplicationInsights({
    config: {
        connectionString,
        enableAutoRouteTracking: true,
        enableAjaxErrorStatusText: true,
        samplingPercentage: 100,
    },
});

// Environments without a connection string configured yet (see .env.*) simply
// run with telemetry off, rather than the SDK throwing on missing config.
if (connectionString) {
    appInsights.loadAppInsights();
}
